import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getEditorialTeamValidationOptions,
  useValidateEditorialTeam,
} from '@/module/Author/EditorialTeam/Validation/model/EditorialTeamValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  editorialTeamId: Id;
  variant?: ValidationVariant;
}

export function EditorialTeamValidationAction({ editorialTeamId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getEditorialTeamValidationOptions(editorialTeamId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateEditorialTeam(editorialTeamId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
